import * as ProtoGameServerBase from './proto_gameserver_base';
import ModelData from '../../../public/model_data';
import ModuleManager from '../../../../framework/core/module_manager';
import NetMsgDataGameServerBase from './net_msg_data_map_gameserver';
import NetPrompt from '../../../public/module/netprompt/netprompt';
import ServerBase from '../server_base';
import SceneManager from '../../../../manager/scene_manager';
import AppData from '../../../public/const/app_data';
import Module from '../../../../framework/core/mvvm/module_base';
import * as ProtoPokerRoom from "../../../table/net/proto/proto_poker_room";
import NetMsgDataBase from "../../../table/net/net_msg_data_table_base";
import EventManager from '../../../../manager/event_manager';
import Utility from '../../../../utility/utility';
import LogManager from '../../../../manager/log_manager';
const { ccclass } = cc._decorator;

@ccclass
export default class GameServer extends ServerBase {

    public static instance: GameServer;

    private _tableLoading = false
    private _serverIsConnect

    private _curTableModule : Module<null, null>

    onLoad() {
        GameServer.instance = this
        this.init("GameServer")
    }

    loginGameServer(url) {
        let self = this
        this._tableLoading = false
        this._serverIsConnect = false

        this.connect(url, function (state) {
            cc.log("connect server state:", state)
        })
    }

    protected onConnected() {
        let self = this
        let text = `连接游戏服成功 ${AppData.gameName}：`
        cc.log(text)
        LogManager.instance.log(text)
        SceneManager.loadingTableModule(null, (tableName) => {
            //curTableModule
            self._curTableModule = ModuleManager.instance.getModule(tableName)
            self.login()
        })
    }

    private login() {
        let self = this
        self.model.subscibeMsgEvent<ProtoGameServerBase.Login.ILoginRsp>(NetMsgDataGameServerBase.Login, function (protoData) {
            self.startCheckPing()
            AppData.serverCurGame = null
            if (protoData.version) {
                let s : any = Utility.jsonParse(protoData.version)
                if (s) {
                    AppData.serverCurGame = s.ver;
                } 
            }
            
            if(protoData.roomId && protoData.roomId > 0 && !protoData.err){
                ModuleManager.instance.hideModule("NetPrompt")
                return
            }
            
            self.close()
            if (protoData.err == -105 || protoData.err == -1) {
                cc.warn("房间已经解散！")                                
            } else if ((protoData.err == -100) ||  (protoData.err == -1)) {
                // ModuleManager.instance.toast('您的账号在其他地方登录')
                SceneManager.gotoAuth()
                return
            }
            SceneManager.gotoHallOrClubHall("TabelExit")
        }, true)

        self.model.subscibeMsgEvent<ProtoPokerRoom.Room.ChatMsgBroadcast>(NetMsgDataBase.ChatNotify, function (protoData) {
            if (self._curTableModule) {
                EventManager.instance.dispatch("show_emoji_msg",self._curTableModule.moduleName,protoData,true)

            }
        }, true)

        self.model.subscibeMsgEvent<ProtoPokerRoom.Room.ChatHistory>(NetMsgDataBase.ChatHistory, function (protoData) {
            if (self._curTableModule) {
                EventManager.instance.dispatch("Event_Notify_GameChatData",protoData);
            }
        }, true)

        let data: ProtoGameServerBase.Login.ILoginReq = {
            account: ModelData.instance.roomInfo.UserID.toString(),
            token: ModelData.instance.roomInfo.Password.toString(),
            roomId:ModelData.instance.roomId
        }
        GameServer.instance.requestLogin(data);
    }

    protected onReconnectServerFail() {
        //TODO:100次连接失败后，需要特别处理，需要在界面提示
        SceneManager.gotoHallOrClubHall("TabelExit")
    }

    protected onReconnectServer() {
        this._tableLoading = false
        this._serverIsConnect = false
        ModuleManager.instance.showModule(NetPrompt, { "showImmediately": true, "reconnect": true })
    }

    requestLogin(data: ProtoGameServerBase.Login.ILoginReq) {
        this.model.sendMsg(NetMsgDataGameServerBase.Login, data);
    }
}
